







import { Component, Prop, Vue } from 'vue-property-decorator'
import { TrelloCard } from '@/TrelloClient'

@Component({
    props: {
        cardId: String,
    },
})
export default class extends Vue {

    label = '✅ Chiudi'

    buttonHandler() {
        this.$store.dispatch('fetchActiveCard', (this as any).cardId).then((card) => {
            if (card.dueComplete === false) {
                this.completeCard()
            } else if (card.dueComplete === true) {
                this.reviveCard()
            } else {
                throw new Error('La card ' + card.shortUrl + 'non è né chiusa né aperta')
            }
        })
    }

    completeCard() {
        let card : TrelloCard = (this as any).card
        this.$store.state.trello.completeCard((this as any).cardId).then(() => {
            console.log('Card chiusa')
            this.label = '🤦🏻‍♂️ Riapri'
        })
    }

    reviveCard() {
        this.$store.state.trello.reviveCard((this as any).cardId).then(() => {
            console.log('Card riaperta')
            this.label = '✅ Chiudi'
        })
    }
}
